import { UserRole } from 'src/auth/types';
import { ScheduleSubject } from '../interfaces/ScheduleSubject.interface';
import { ScheduleEmployee } from '../interfaces/ScheduleEmployee.interface';
import DateTimeUtils from 'src/utils/datetime';
import { UserRoleToAPIPathMap } from '../const/ScheduleCalendar.const';
import axiosApiInstance from 'src/api/axiosConfig';

export const fetchEmployeesData = async (
    educationLevelRange: string,
    role: UserRole,
    subjectId: ScheduleSubject['id'],
    rangeStart: Date,
    educationCenterId?: number,
    includeRole?: boolean
): Promise<ScheduleEmployee[] | undefined> => {
    const roleApiPath = UserRoleToAPIPathMap[role];

    const params: Record<string, string> = {
        targetGradeRange: educationLevelRange,
        subjectId: String(subjectId),
        weekDate: DateTimeUtils.getFormattedDate(rangeStart),
        educationCenterId: educationCenterId ? educationCenterId.toString() : ''
    };

    if (includeRole) {
        params.role = role;
    }

    const queryString = new URLSearchParams(params).toString();

    const { data } = await axiosApiInstance.get(`employees/${roleApiPath}?${queryString}`);
    return data;
};
